import { BreadcrumbData } from 'zens-storybook'
import { useTranslation } from 'react-i18next'
import { useNumberParams } from 'zens-router'

export const useBreadcrumb = (data?: BreadcrumbData[]) => {
  const [{ companyId }] = useNumberParams()
  const { t } = useTranslation()
  return [
    {
      title: t('Home'),
      href: `/companies/${companyId}`,
    },
    ...(data ? data : []),
  ] as BreadcrumbData[]
}
